import BaseLayout from '@modules/_shared/components/report-editor/layout/BaseLayout';
import DesktopPreview from '@modules/_shared/components/report-editor/preview/DesktopPreview';

const DesktopLayout = () => (
  <BaseLayout mode="desktop" renderPreview={() => <DesktopPreview />} />
);

export default DesktopLayout;
